export default __webpack_public_path__ + "img/i-cross.008efbbe.svg";